<template>
  <form @submit.prevent="handleSubmit">
    <h1>Add a new project to the portfolio</h1>
    <input type="text" placeholder="Title" v-model="title" />
    <input type="text" placeholder="Project url" v-model="projectUrl" />
    <label>Project Thumbnail</label>
    <input type="file" @change="handleFile" />
    <div class="error">{{ fileError }}</div>
    <div class="checkbox-container">
      <div class="checkbox">
        <label for="react">React</label>
        <input
          type="checkbox"
          v-model="react"
          true-value="yes"
          false-value="no"
        />
      </div>
      <div class="checkbox">
        <label for="vue">Vue</label>
        <input
          type="checkbox"
          v-model="vue"
          true-value="yes"
          false-value="no"
        />
      </div>
      <div class="checkbox">
        <label for="firebase">Firebase</label>
        <input
          type="checkbox"
          v-model="firebase"
          true-value="yes"
          false-value="no"
        />
      </div>
    </div>
    <div class="error">{{ error }}</div>
    <button v-if="!isPending">Create</button>
    <button v-else disabled>Loading...</button>
  </form>
</template>

<script>
import { ref } from 'vue';
import { timestamp } from '@/firebase/config';
import useStorage from '@/composables/useStorage';
import useCollection from '@/composables/useCollection';
import getUser from '@/composables/getUser';

export default {
  setup() {
    const { filePath, url, uploadImage } = useStorage();
    const { error, addDoc } = useCollection('projects');
    const { user } = getUser();

    const title = ref('');
    const projectUrl = ref('');
    const file = ref(null);
    const fileError = ref(null);
    const isPending = ref(false);
    const react = ref('no');
    const vue = ref('no');
    const firebase = ref('no');

    const handleSubmit = async () => {
      if (file.value) {
        isPending.value = true;

        await uploadImage(file.value);
        const res = await addDoc({
          title: title.value,
          projectUrl: projectUrl.value,
          thumbnailUrl: url.value,
          filePath: filePath.value,
          react: react.value,
          vue: vue.value,
          firebase: firebase.value,
          createdAt: timestamp(),
        });
        isPending.value = false;

        if (!error.value) {
          // Reset all fields
          title.value = '';
          projectUrl.value = '';
          file.value = null;
          react.value = 'no';
          vue.value = 'no';
          firebase.value = 'no';
          fileError.value = null;
          document.querySelector('form').reset(); // Reset file input
        }
      }
    };

    const types = ['image/png', 'image/jpeg'];

    const handleFile = (e) => {
      const selected = e.target.files[0];

      if (selected && types.includes(selected.type)) {
        file.value = selected;
        fileError.value = null;
      } else {
        file.value = null;
        fileError.value = 'Please select an image file (png or jpeg)';
      }
    };
    return {
      title,
      projectUrl,
      file,
      react,
      vue,
      firebase,
      fileError,
      isPending,
      error,
      handleSubmit,
      handleFile,
    };
  },
};
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
  max-width: 350px;
  height: fit-content;
  margin: 2rem auto;
  padding: 2rem;
  border: 1px solid black;
  border-radius: 5px;
  background: white;
}

h1 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 500;
  color: black;
}

input[type='text'],
input[type='file'] {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  margin-bottom: 15px;
  border: 1px solid black;
  background: white;
  color: black;
  font-size: 1rem;
  border-radius: 3px;
}

input[type='text']:focus {
  outline: none;
  border: 1px solid black;
}

label {
  font-size: 0.85rem;
  color: black;
  font-weight: 500;
  margin-top: 10px;
}

.checkbox-container {
  display: flex;
  justify-content: space-between; /* Ensures even spacing between the checkboxes */
  align-items: center;
  margin-top: 10px;
  gap: 15px; /* Adds space between items */
}

.checkbox {
  display: flex;
  align-items: center; /* Aligns the checkbox and label vertically */
  gap: 5px; /* Adds spacing between the checkbox and label */
  margin: 0; /* Removes any extra margins */
}

input[type='checkbox'] {
  margin: 0; /* Ensures the checkbox is not adding unwanted margin */
  vertical-align: middle; /* Aligns the checkbox with the label text */
}

.checkbox label {
  font-size: 1rem;
  color: black;
  cursor: pointer;
  margin: 0; /* Ensures consistent spacing */
}

.error {
  font-size: 0.8rem;
  color: red;
  margin-top: 5px;
}

button {
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  font-size: 1rem;
  font-weight: bold;
  color: white;
  background: black;
  border: none;
  cursor: pointer;
  border-radius: 3px;
  transition: background 0.2s;
}

button:hover {
  background: #333;
}

button:disabled {
  background: #666;
  cursor: not-allowed;
}
</style>
